export const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL
export const API_END_POINT = process.env.REACT_APP_PUBLIC_API_END_POINT
export const API_END_POINT_URL =
	process.env.REACT_APP_API_PROTOCOL && process.env.REACT_APP_PUBLIC_API_END_POINT
		? `${process.env.REACT_APP_API_PROTOCOL}${process.env.REACT_APP_PUBLIC_API_END_POINT}`
		: ''
export const IMG_STORAGE_URL = process.env.REACT_APP_IMG_STORAGE_DOMAIN
	? `https://${process.env.REACT_APP_IMG_STORAGE_DOMAIN}`
	: ''

export const MOTINERS_URL =
	process.env.REACT_APP_MOTINERS_DOMAIN && process.env.REACT_APP_MOTINERS_PROTOCOL
		? `${process.env.REACT_APP_MOTINERS_PROTOCOL}${process.env.REACT_APP_MOTINERS_DOMAIN}`
		: ''

export const APP_URL =
	process.env.NODE_ENV === 'development' ? 'http://localhost:3010' : 'https://studio.motiners.com'

export const TOSS_CLIENT_KEY = process.env.REACT_APP_TOSS_CLIENT_KEY

export const FIREBASE_CONFIG = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_PROJECT_ID
		? `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`
		: undefined,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_PROJECT_ID
		? `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`
		: undefined,
	messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
		? `G-${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`
		: undefined,
}
